import { IsoDateTime, IsoDateTimeTz, IsoTimeOffset } from '../../../types/iso-date';

export function toIsoDateTimeTz(date: Date | IsoDateTime, timeZone: string): IsoDateTimeTz {
  if(!(date instanceof Date)) {
    date = new Date(date);
  }
  const svDate = new Intl.DateTimeFormat('sv-SE', {
    timeZone: timeZone,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: false,
    timeZoneName: 'longOffset'
  }).format(date);
  // svDate expected format: "YYYY-MM-DD HH:mm:ss GMT±HHMM" or "YYYY-MM-DD HH:mm:ss UTC"
  const [datePart, timePart, tzToken] = svDate.split(' ');

  // Normalize timezone token to offset string
  let offset: IsoTimeOffset;
  if (tzToken === 'UTC' || tzToken === 'GMT') {
    offset = 'Z' as IsoTimeOffset;
  } else {
    // Remove leading 'GMT' if present, and optional colon between HH and MM
    const tzAbbr = tzToken.replace(/^GMT/, ''); // e.g., '+0230' or '-1130'
    const m = /^([+-])(\d{2}):?(\d{2})$/.exec(tzAbbr);
    if (m) {
      const [, sign, hh, mm] = m;
      if (hh === '00' && mm === '00') {
        offset = 'Z' as IsoTimeOffset;
      } else {
        offset = `${sign}${hh}:${mm}` as IsoTimeOffset;
      }
    } else {
      // Fallback to Z if not recognized
      offset = 'Z' as IsoTimeOffset;
    }
  }

  const ms = date.getMilliseconds().toString().padStart(3, '0');
  return `${datePart}T${timePart}.${ms}${offset}` as IsoDateTimeTz;
}
